exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-16634610] {\n  width: 115px;\n  height: 115px;\n  position: relative;\n  padding: 5px 0px 0px 10px !important;\n  overflow: hidden;\n  margin-left: 20px;\n}\n.container img[data-v-16634610] {\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.container p[data-v-16634610] {\n  font-size: 1.1rem;\n  position: absolute;\n  font-family: 'Asap, sans-serif';\n  top: 50%;\n  left: 55%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.container[data-v-16634610]:hover {\n  width: 115px;\n  height: 112px;\n}\n", ""]);

// exports
